import React, {useState} from "react"
import {toast} from "react-toastify"
import {Form} from "semantic-ui-react"
import {inject, observer} from "mobx-react"
import { useSettings, DETACH_CONVERSATION_BUTON } from "../../../../core/hooks"

const DetachConversationBtn = ({ store, actions }) => {
  const [loading, setLoading] = useState(false)
  const [disabledButton, setDisabledButton] = useState(true)
  useSettings(store, disabledButton, setDisabledButton, DETACH_CONVERSATION_BUTON)

  const handleDetachConversation = async(e) => {
    e.preventDefault()
    const conversationUid = store.conversation.conversationUid
    setLoading(true)
    await actions.agent.detachConversation(conversationUid, false, true)
      .then(([response, error]) => {
        if (error) {
          toast.error('There was an error detaching this conversation, please try again.')
          return
        }
        if (response) {
          if (store.conversations.length < parseInt(store.config.maxConversations)) {
            actions.agent.fetchMoreConversations(false)
          }
          toast.info('Successfully removed the conversation.')
        }
      })
    setLoading(false)
  }

  const Button = ({ onClick, text }) => (
    <Form.Button
      size="small"
      color="facebook"
      style={{ fontWeight: 'normal' }}
      disabled={disabledButton}
      onClick={onClick}
      loading={loading}
    >
      {text}
    </Form.Button>
  )

  return (<Button
    onClick={handleDetachConversation}
    text={'Remove Conversation'}
    disabled={disabledButton}
    loading={loading}
  />)
}

export default inject('store', 'actions')(observer(DetachConversationBtn))
